<template>
  <div class="departmentManage">
    <el-tabs type="border-card" style="width: 100%; height: 100%">
      <el-tab-pane label="部门列表">
        <div class="main_boby">
          <div
            class="left_nav"
            :style="functOverflow()"
            v-loading="tree_loading"
            element-loading-text="拼命加载中!"
          >
            <div class="block">
              <!-- show-checkbox -->
              <el-tree
                :data="treedata"
                :expand-on-click-node="false"
                ref="nav_left"
                node-key="id"
                :height="table_height"
                highlight-current
                default-expand-all
                :current-node-key="currentNodekey"
                @current-change="onTreeCurrentChange"
              >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span>{{ node.label }}</span>
                  <span>
                    <el-tooltip
                      content="添加"
                      :disabled="accessControl.department"
                      effect="light"
                      placement="top"
                      :enterable="false"
                      v-if="data.id != 0"
                    >
                      <!-- :disabled="accessControl.departmentmanageadd" -->
                      <el-button
                        style="padding: 0px; height: 26px; min-height: 26px"
                        type="text"
                        icon="el-icon-plus"
                        :underline="false"
                        @click="
                          () =>
                            accessControl.department
                              ? accessControl.department
                              : append(data)
                        "
                      ></el-button>
                    </el-tooltip>
                    <template
                      v-if="data.id != 0 && data.id != -1 && node.isLeaf"
                    >
                      <!-- :disabled="accessControl.departmentmanagedel" -->
                      <el-popconfirm
                        title="确定删除该标签吗?"
                        @confirm="
                          () =>
                            accessControl.editmanage
                              ? accessControl.editmanage
                              : remove(node, data)
                        "
                      >
                        <template #reference>
                          <el-button
                            style="
                              padding: 0px;
                              height: 26px;
                              min-height: 26px;
                              margin: 0;
                            "
                            type="text"
                            icon="el-icon-delete"
                          >
                          </el-button>
                        </template>
                      </el-popconfirm>
                    </template>
                  </span>
                </span>
              </el-tree>
            </div>
          </div>
          <div class="main_content">
            <div class="content">
              <div class="table_form">
                <el-form
                  style="width: 80%; min-width: 800px"
                  ref="branch_main_data"
                  label-width="80px"
                  size="mini"
                  :model="Branch_main_form"
                  @submit.prevent
                >
                  <div style="width: 100%; display: flex">
                    <el-form-item style="width: 50%" label="标题：" prop="name">
                      <el-input
                        type="text"
                        placeholder="不填则启用默认名称"
                        v-model="Branch_main_form.name"
                        :disabled="isDisabled"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div style="width: 100%; display: flex">
                    <el-form-item
                      style="width: 50%"
                      label="备注："
                      prop="remark"
                    >
                      <el-input
                        type="textarea"
                        rows="9"
                        v-model="Branch_main_form.remark"
                        :disabled="isDisabled"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div style="width: 100%; display: flex">
                    <el-form-item>
                      <el-button
                        type="primary"
                        v-cloak
                        style="margin-left: 0 !important"
                        @click="submit_branch_main"
                        :disabled="accessControl.department"
                        :loading="disabledBtn"
                      >
                        {{ '保存' }}
                      </el-button>
                    </el-form-item>
                  </div>
                </el-form>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
// import { request } from '../dataApi/_request/index'

// import Api from '../apis/api'
import {
  getBranch,
  addBranch,
  modifyBranch,
  deleteBranch
} from '../common/commons'
export default {
  name: 'DepartmentManage',
  props: {
    userData: {
      type: Object,
      require: true,
      default: function () {
        return {}
      }
    }
  },
  watch: {
    localUserData(newVal) {
      this.localUserData = newVal
    }
  },
  data() {
    return {
      localUserData: this.userData,
      disabledBtn: false,
      table_height: 0,
      treedata: [],
      checked_keys: [4],
      origin_userInfo: [],
      manager_id: '',
      tree_loading: false,
      currentNodekey: -1,
      isAdd: false,
      isDisabled: true,
      fullscreenLoading: false,
      Branch_main_form: {
        name: '',
        remark: ''
      },
      currentAddedTreeNodeId: '',
      accessControl: {}
    }
  },
  mounted() {
    window.addEventListener('resize', this.OnResize())
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.OnResize())
  },
  created() {
    this.Branch_main_form.manager_id = this.localUserData.data.row_id
    this.manager_id = this.localUserData.data.row_id
    this.destination_id = this.localUserData.data.destination_id
    console.log(this.localUserData, 'userData  所有')
    this.invertFilterValues()
    console.log(this.accessControl, 'accessControl')
    this.init_table_height()
    this.getTreeData()
  },
  methods: {
    functOverflow() {
      if (this.treedata.length !== 0) {
        return {
          'overflow-y': 'scroll'
        }
      }
    },
    handleNodeClick(data) {
      console.log(data)
    },
    invertFilterValues() {
      this.accessControl = Object.keys(this.localUserData.data.right).reduce(
        (result, key) => {
          result[key] = !this.localUserData.data.right[key]
          return result
        },
        {}
      )
    },
    handleTreeChange(e, checked) {
      if (checked) {
        let arr = [e.id]
        this.$refs.nav_left.setCheckedKeys(arr)
        this.checked_keys = [e.id]
      } else {
        let arr = [e.id]
        this.$refs.nav_left.setCheckedKeys(arr)
      }
    },
    //获取树形结构
    getTreeData() {
      this.tree_loading = true
      getBranch({
        destination_id: this.destination_id
      }).then((res) => {
        console.log('ss', res)
        let branchList = []
        res.data.forEach((items) => {
          branchList.push({
            id: items.row_id,
            label: items.name,
            name: items.name,
            remark: items.remark,
            parent_id: items.parent_id,
            manager_id: items.manager_id
          })
        })
        const branchTree = arrayToTree(branchList)
        function arrayToTree(items) {
          const result = [] // 存放结果集
          const itemMap = {} //
          for (const item of items) {
            const id = item.id
            const parent_id = item.parent_id

            if (!itemMap[id]) {
              itemMap[id] = {
                children: []
              }
            }

            itemMap[id] = {
              ...item,
              children: itemMap[id]['children']
            }

            const treeItem = itemMap[id]

            if (parent_id === '0') {
              result.push(treeItem)
            } else {
              if (!itemMap[parent_id]) {
                itemMap[parent_id] = {
                  children: []
                }
              }
              itemMap[parent_id].children.push(treeItem)
            }
          }
          return result
        }
        let rootData = [
          {
            label: '部门目录',
            id: -1,
            parent_id: -1,
            children: branchTree
          }
        ]
        this.treedata = rootData
        console.log('tt', rootData)
        if (this.treeData) {
          this.currentNodekey = this.treeData[0].id
          this.$nextTick(() => {
            this.$refs.nav_left.setCurrentKey(this.currentNodekey)
            this.$nextTick(() => {
              document.querySelector('.is-current').firstChild.click()
            })
          })
        }
        this.tree_loading = false
      })
    },
    //初始化高度
    init_table_height(redundant = 250) {
      this.table_height = document.body.clientHeight - redundant
    },
    OnResize() {
      this.init_table_height()
    },
    append(data, node) {
      if (!data.children == -1) {
        //判断是否无父级元素
        console.log('-1')
        data.ids = 0
      } else {
        console.log('0')
        data.ids = data.id
      }
      if (!data.children) {
        //如果没有子级元素，新增一个子级元素
        this.$set(data, 'children', [])
      }
      const newChild = {
        label: '新增部门',
        id: 0,
        name: '新增部门',
        remark: '新增部门',
        parent_id: data.ids
      }
      //判断是否已有新增资源
      let isHave = false
      for (const i of data.children) {
        if (i.id == 0) {
          isHave = true
        }
      }
      if (!isHave) {
        data.children.push(newChild)
      }
      this.currentNodekey = 0
      this.isAdd = true
      this.Branch_main_form.name = '新增部门'
      this.Branch_main_form.remark = '新增部门'
      this.Branch_main_form.parent_id = data.id == '-1' ? 0 : data.id
      this.isDisabled = false
      this.$refs.nav_left.setCheckedKeys([newChild.id])
      this.$nextTick(() => {
        const newNode = this.$refs.nav_left.getNode(newChild.id)
        this.currentAddedTreeNodeId = newNode.id
        console.log(this.currentAddedTreeNodeId, 'this.currentAddedTreeNodeId')
        document.getElementById(this.currentAddedTreeNodeId)
        // .scrollIntoView();
      })
    },
    remove(node, data) {
      const parent = node.parent
      const children = parent.data.children || parent.data
      const index = children.findIndex((d) => d.id === data.id)
      children.splice(index, 1)
      this.deleteResource(node, data)
      this.currentNodekey = node.parent.data.id
      this.$refs.nav_left.setCurrentKey(this.currentNodekey)
      this.Branch_main_form.id = node.parent.data.id
      this.Branch_main_form.name = node.parent.data.name
      this.Branch_main_form.remark = node.parent.data.remark
      if (node.parent.data.id === -1) {
        this.isDisabled = true
      } else {
        this.isDisabled = false
      }
    },
    //选中节点
    onTreeCurrentChange(data, node) {
      this.$nextTick(() => {
        this.hideItem = node.isLeaf
      })
      console.log(data, node)
      //debugger
      if (this.isAdd) {
        this.isAdd = false
        this.$nextTick(() => {
          this.$refs.nav_left.setCurrentKey(this.currentNodekey)
        })
      } else {
        if (data.id != this.currentNodekey && this.currentNodekey == 0) {
          this.removeTreeDataItem(this.treedata)
        }
        this.currentNodekey = data.id
        console.log(data)
        this.Branch_main_form = data
        this.Branch_main_form.manager_id = this.manager_id

        this.currentNode = node
        if (data.id == -1) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      }
    },
    removeTreeDataItem(arr) {
      let that = this
      arr.forEach(function (item, index) {
        if (item.id == 0) {
          arr.splice(index, 1)
        }
        if (item.children && item.children.length > 0) {
          that.removeTreeDataItem(item.children)
        }
      })
    },
    submit_branch_main() {
      // this.$refs[formName].validate(valid => {
      //     if (valid) {
      if (this.currentNodekey >= 0) {
        if (this.currentNodekey == 0) {
          console.log('m')
          this.addResource()
        } else {
          console.log('a')
          this.modifyResource()
        }
      }
    },
    //新增权限
    addResource() {
      // this.disabledBtn = true;
      this.fullscreenLoading = true
      this.Branch_main_form.destination_id = this.destination_id

      // let params = {
      //   method: 'post',
      //   url: Api.addBranch,
      //   data: this.Branch_main_form,
      //   headers: {
      //     'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      //   }
      // }
      // request(params)
      addBranch({
        data: this.Branch_main_form
      })
        .then((res) => {
          if (res.errcode === 0) {
            this.$message({
              message: '新增成功！',
              type: 'success',
              duration: 800
            })
            this.disabledBtn = false
            this.getTreeData()
            this.Branch_main_form.id = res.data.result
            this.Branch_main_form.label = this.Branch_main_form.name
            this.currentNodekey = res.data.result
            this.fullscreenLoading = false
          } else {
            this.$message({
              message: '新增失败！',
              type: 'error',
              duration: 800
            })
            this.disabledBtn = false
            this.getTreeData()
            this.fullscreenLoading = false
          }
        })
        .catch(() => {
          this.disabledBtn = false
        })
    },
    //修改权限
    modifyResource() {
      this.disabledBtn = true
      this.fullscreenLoading = true
      this.Branch_main_form.destination_id = this.destination_id
      // let params = {
      //   method: 'post',
      //   url: Api.modifyBranch,
      //   data: this.Branch_main_form,
      //   headers: {
      //     'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      //   }
      // }
      // request(params)
      modifyBranch({
        data: this.Branch_main_form
      })
        .then((res) => {
          console.log(res)
          if (res.errcode === 0) {
            this.$message({
              message: '修改成功！',
              type: 'success',
              duration: 800
            })
            this.getTreeData()
            this.disabledBtn = false
            this.Branch_main_form.id = res.data.result
            this.Branch_main_form.label = this.Branch_main_form.name
            this.currentNodekey = res.data.result
            this.fullscreenLoading = false
          } else {
            this.$message({
              message: '修改失败！',
              type: 'error',
              duration: 800
            })
            this.getTreeData()
            this.disabledBtn = false
            this.fullscreenLoading = false
          }
        })
        .catch(() => {
          this.disabledBtn = false
          this.$ElMessage.error('网络错误！')
        })
    },
    //删除权限
    deleteResource(node, nodeData) {
      this.fullscreenLoading = true
      let data = { row_id: nodeData.id }
      // let params = {
      //   method: 'post',
      //   url: Api.deleteBranch,
      //   data: {
      //     data: data
      //   },
      //   headers: {
      //     'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      //   }
      // }
      // request(params)
      deleteBranch({
        data: data
      }).then((res) => {
        console.log(res)
        if (res.errcode === 0) {
          this.$message({
            message: '删除成功！',
            type: 'success',
            duration: 800
          })
          this.getTreeData()
          this.fullscreenLoading = false
        } else {
          this.$message({
            message: '删除失败！',
            type: 'error',
            duration: 800
          })
          this.getTreeData()
          this.fullscreenLoading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.departmentManage {
  .el-tree {
    position: relative;
    cursor: default;
    background: #fff;
    color: #606266;
    height: calc(100vh - 85px);
  }
  width: 100%;
  height: 92vh;
  :deep(.el-input) {
    width: 360px;
  }
  :deep(.el-tree-node__content) {
    position: relative;
  }
  :deep(.el-form-item__content) {
    width: 360px;
    margin-left: 0 !important;
  }
  :deep(.el-form-item__content) {
    display: flex;
    align-items: center;
  }
  :deep(.el-textarea__inner) {
    width: 360px;
  }
  :deep(.el-form-item) {
    display: flex;
    margin-bottom: 8px;
  }
  .el-tabs__header {
    padding: 0;
    position: relative;
    margin: 0;
  }
  ::v-deep.el-tabs__content {
    padding: 12px 15px;
  }
  .main_boby {
    width: 100%;
    height: 100%;
    display: flex;
    margin-top: 10px;
    margin-left: 12px;
  }
  .header_button {
    width: 100%;
    border-bottom: 1px solid #e4e9e8;
    display: flex;
    padding-bottom: 15px;
  }
  :deep(.el-form-item__label) {
    flex: 0 0 auto;
    text-align: right;
    font-size: 12px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
    box-sizing: border-box;
  }
  :deep(.el-tabs__item) {
    padding: 0 20px;
    height: 40px;
    box-sizing: border-box;
    line-height: 40px;
    display: inline-block;
    list-style: none;
    font-size: 12px;
    font-weight: 500;
    color: #303133;
    position: relative;
  }
  .left_nav {
    width: 330px;
    height: 82vh;
    /* overflow-y: scroll; */
    border: 1px solid rgb(230, 230, 230);
    flex-shrink: 0;
  }
  .main_content {
    width: 100%;
    height: 100%;
  }
  .content {
    width: 100%;
    height: 100%;
  }
  .table_form {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0;
    overflow-y: auto;
  }
  .node_highlight {
    background-color: #098f24;
  }
  .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: #098f24;
    position: relative;
  }
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  padding-right: 8px;
}
:deep(.el-scrollbar__wrap.el-scrollbar__wrap--hidden-default) {
  height: 900px !important;
}
</style>
